@if (numberOfButtons > 1) {
	<button mat-mini-fab color="primary" class="more-button" type="button"
		data-test-id="more-button" (mouseenter)="showMore()" (mouseleave)="hideMore()"
		(keyup.enter)="showMore()" (keyup.escape)="hideMore()"
		(click)="showMore()"
		(focus)="showMore()"
		(focusout)="focusChanged($event)"
		[attr.aria-haspopup]="'menu'"
		[attr.aria-label]="'Weitere Funktionen'"
		[matTooltip]="tooltip"
		[matTooltipPosition]="position">
	<mat-icon>more_vert</mat-icon>
	<div class="more-buttons-container" #moreButtonsContainer (mouseenter)="mouseMovedToMore()">
		<div class="more-buttons">
			<ng-container *ngTemplateOutlet="buttons"/>
		</div>
	</div>
</button>
}

@if (numberOfButtons == 1) {

	<ng-container *ngTemplateOutlet="buttons"/>

}

<ng-template #buttons>
	<span data-test-id="more-button-buttons" class="button-list"><ng-content/></span>
</ng-template>
